'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _createReducer2 = require('../createReducer');

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = require('./actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function pageStatusSet(settingsState, action) {
  if (action.status === settingsState.pageStatus || action.status < settingsState.pageStatus) {
    return settingsState;
  }

  return (0, _extends3.default)({}, settingsState, {
    pageStatus: action.status,
    pageError: action.error
  });
}

var reducer = (0, _createReducer3.default)({
  pageStatus: 200,
  pageError: undefined
}, (0, _defineProperty3.default)({}, _actions.PAGE_STATUS, pageStatusSet));

exports.default = reducer;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/ServerSide/reducer.js
// module id = 876
// module chunks = 0